var $c90374e1918efa36$exports = {};
$c90374e1918efa36$exports = {
    "valid": `\u{C720}\u{D6A8}`
};


export {$c90374e1918efa36$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
